import type { CalculatorMeta } from '../../types/calculator';

const meta: CalculatorMeta = {
  route: '/moving-cost-calculator',
  component: () => import('../../routes/MovingCost.svelte'),
  card: {
    id: 'moving-cost',
    title: 'Moving Cost Calculator',
    description: 'Estimate the total cost of your household move including truck rental, labor, packing supplies, and storage.',
    icon: 'local_shipping',
    iconBgClass: 'bg-amber-50',
    iconTextClass: 'text-amber-600',
    href: '/moving-cost-calculator',
    category: 'Travel & Distance',
  },
  seo: {
    title: 'Moving Cost Calculator – Free Household Move Estimate',
    description: 'Free moving cost calculator. Estimate expenses for truck rental, professional movers, packing supplies, fuel, storage, and insurance for your household move.',
  },
};

export default meta;